import React from 'react';
import SideMenu from './side-menu/index';
import NewSideMenuTwo from './new-side-menu-2.0';
import useSlideMenuCollapsedChange from '@/hooks/useSlideMenuCollapsedChange';
import OutestBreadCrumbs from './outest-bread-crumbs';
import classnames from 'classnames';
import './index.less';
import { getQuery } from '@/common/utils';
import { connect } from 'react-redux';
import { beInjectedInIframe } from '@/common/utils/beInectedIn';

function OutestLayout(props) {
  const [sidemenuCollapsed] = useSlideMenuCollapsedChange('side-menu-collapsed', '');
  const outestWrapClassnames = classnames('outest-wrap outest-container', sidemenuCollapsed);
  const { roleRules } = props;

  if (beInjectedInIframe() || props.roleIsKf) {
    return props.children;
  }

  return (
    <div className={outestWrapClassnames} style={{ paddingLeft: getQuery('origin') === 'Babel' ? 0 : '' }}>
      {/* 如果角色列表里没有返回业务角色就使用老版本路由*/}
      {roleRules && roleRules.length ? <NewSideMenuTwo /> : <SideMenu />}
      <OutestBreadCrumbs />
      {props.children}
    </div>
  );
}

export default connect((state) => {
  return {
    roleRules: state.userInfo.roleRules,
    roleIsKf: state.userInfo?.roles?.some((role) => role.roleId === 26),
  };
})(OutestLayout);
